module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q4_2025_shadowline_btn.624f4ec8.png";